export enum TabIdEnum {
    ADMINISTRATION = 'administration',
    AZURE = 'azure',
    CONTACTS = 'contacts',
    DEPARTMENT = 'department',
    DOCUMENTS = 'documents',
    EMAIL = 'email',
    FAVORITES = 'favorites',
    FOLDER = 'folder',
    GENERAL = 'general',
    INDUSTRY = 'industry',
    SELECTION = 'selection',
    USERGROUPS = 'usergroups',
    USERS = 'users',
    VAULTS = 'vaults',
}
